import {
  type CategorizedResponse,
  GroundSelectionEnum,
  type Suggestion,
  PlaceIdEnum,
  AutocompleteCategory,
} from "@b2bportal/ground-api";
import { CarNavigationUtility, carsApi } from "../../../../../utilities";
import type { CarLocationSuggestion } from "~core-cars/components/featureComponents";
export const fetchGroundLocationAutocomplete = async (
  query: string
): Promise<CategorizedResponse[]> => {
  const res = await carsApi.apiV1AutocompleteGroundPost({
    query: { l: query, LocationQuery: "Label" },
  });
  return res.data.categories;
};

export const fetchPlace = async (
  query: string
): Promise<CarLocationSuggestion | undefined> => {
  const locations = await fetchGroundLocationAutocomplete(
    CarNavigationUtility.urlToPlaceQuery(query)
  );

  const airports = getSuggestionsByCategory(
    locations,
    AutocompleteCategory.airports
  );
  const places = getSuggestionsByCategory(
    locations,
    AutocompleteCategory.places
  );

  if (airports != null) {
    const airport = airports.find(
      (location: CarLocationSuggestion) =>
        CarNavigationUtility.placeSuggestionToUrl(location) === query
    );
    if (airport != null) {
      return airport;
    }
  }

  if (places == null) {
    return undefined;
  }

  // Try to find a geo location
  const geoLocation = places.find(
    (location: CarLocationSuggestion) =>
      location.id.Id === PlaceIdEnum.Grounds &&
      location.id.groundSelection.GroundSelection ===
        GroundSelectionEnum.Place &&
      location.id.groundSelection.placeTypes.includes("geocode")
  );

  // Return geo location or first location
  return (
    geoLocation ??
    (() => {
      const firstResult = locations[0]?.results.shift();
      return firstResult
        ? {
            ...firstResult,
            category: locations[0].category,
            categoryLabel: locations[0].label,
          }
        : undefined;
    })()
  );
};

function getSuggestionsByCategory(
  categories: CategorizedResponse[],
  category: AutocompleteCategory
): CarLocationSuggestion[] | undefined {
  const selectedCategory = categories.find(
    (suggestion) => suggestion.category === category
  );

  return selectedCategory?.results.map((d) => ({
    ...d,
    category: selectedCategory.category,
    categoryLabel: selectedCategory.label,
  }));
}
